<template>
    <b-card>
        <div class="user-avatar-section">
            <div class="d-flex align-items-center flex-column">
                <div class="avatar bg-light-danger avatar-xl mt-1 mb-2">
                    <span class="avatar-content">CF</span>
                </div>
                <div class="user-info text-center">
                    <h4 >{{ userStore.user.full_name }}</h4>
                    <span class="badge bg-light-success">{{ userStore.profile.userRole }}</span>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-around my-2 pt-75" v-if="!userStore.profile.isBusiness">
            <div class="d-flex align-items-start me-2">
                <span class="badge bg-light-primary p-75 rounded" style="">
                    <vue-feather
                        type="hash"
                    ></vue-feather>
                </span>
                <div class="" style="margin-left: 0.75rem!important">
                    <h4 class="mb-0">{{ userStore.profile.identityIQ }}</h4>
                    <small>Total Credit Pull</small>
                </div>
            </div>
            <div class="d-flex align-items-start">
                <span class="badge bg-light-primary p-75 rounded">
                    <vue-feather
                        type="layers"
                    ></vue-feather>
                </span>
                <div class="" style="margin-left: 0.75rem!important">
                    <h4 class="mb-0">{{ userStore.profile.lettersCount }}</h4>
                    <small>Total Dispute Latters</small>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-start my-2 pt-75" v-else>
            <div class="d-flex align-items-start me-2">
                <span class="badge bg-light-primary p-75 rounded" style="">
                    <vue-feather
                        type="hash"
                    ></vue-feather>
                </span>
                <div class="" style="margin-left: 0.75rem!important">
                    <h4 class="mb-0">{{ userStore.profile.user.client_count }}</h4>
                    <small>Total Clients</small>
                </div>
            </div>
        </div>
        <h4 class="fw-bolder border-bottom pb-50 mb-1 mt-1">Details</h4>
        <div class="info-container">
            <ul class="list-unstyled">
                <li class="mb-1">
                    <span class="fw-bolder" style="margin-right: 0.25rem !important;font-weight:bolder;">Fullname :</span>
                    <span>{{ userStore.user.full_name }}</span>
                </li>
                <li class="mb-1">
                    <span class="fw-bolder" style="margin-right: 0.25rem !important;font-weight:bolder;">Billing Email :</span>
                    <span>{{ userStore.user.email }}</span>
                </li>
                <!-- show plan  -->
                <li class="mb-1" v-if="userStore.profile.user_subscription_ended">
                    <span class="fw-bolder" style="margin-right: 0.25rem !important;font-weight:bolder;">Plan :</span>
                    <span class="badge bg-light-warning" >{{ userStore.profile.user.my_plan}}</span>
                </li>
                <li class="mb-1" v-else>
                    <span class="fw-bolder" style="margin-right: 0.25rem !important;font-weight:bolder;">Plan :</span>
                    <span class="badge bg-light-success" v-if="userStore.profile.plan !== null">{{ userStore.profile.plan }}</span>
                    <span class="badge bg-light-warning" v-else>No Active Plan</span>
                </li>
                <!-- end show plan -->
                <li class="mb-1" v-if="!userStore.profile.isBusiness">
                    <span class="fw-bolder" style="margin-right: 0.25rem !important;font-weight:bolder;">Credit Report Type :</span>
                    <span>{{ userStore.user.credit_report_type }}</span>
                </li>
                <li class="mb-1">
                    <span class="fw-bolder" style="margin-right: 0.25rem !important;font-weight:bolder;">Contact :</span>
                    <span>{{ userStore.user.phone }}</span>
                </li>
                <li class="mb-1">
                    <span class="fw-bolder" style="margin-right: 0.25rem !important;font-weight:bolder;">Credit Balance:</span>
                    <span v-if="userStore.user.balance">
                        ${{ fix(userStore.user.balance, settingStore.payment.precision) }}
                    </span>
                </li>
                <li class="mb-75 fw-bolder border-bottom">
                </li>
                <li class="mb-1" v-if="userStore.user.email_verified_at !=null">
                    <span class="fw-bolder" style="margin-right: 0.25rem !important;font-weight:bolder;">Email Verified :</span>
                    <span class="badge bg-light-primary">Your Email is Verified!</span>
                </li>
            </ul>
            <div class="d-flex justify-content-center pt-2">
                <a href="javascript:;" class="btn btn-primary waves-effect waves-float waves-light mr-50" @click="openModal('#editUser')">
                    Edit User
                </a>
                <a href="javascript:void(0)" class="btn btn-outline-danger suspend-user waves-effect mr-50" data-target="#deactivate-reason-modal" data-toggle="modal" v-on:click="setDeactivateType(userStore.DEACTIVATE_ACCOUNT)" v-if="userCanceled">Deactivate Account</a>
            </div>
        </div>
    </b-card>
    <profile-modal />
    <add-phone-component/>
</template>
<script>
import {
  BCard, BButton, BAvatar, BRow, BCol,
} from 'bootstrap-vue-3'
import axios from 'axios'
import {ref} from 'vue'
import AddPhoneComponent from './component/AddPhoneComponent.vue'
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import { useUserStore } from '../../../stores/UserStore.js'
import { useLocalizationStore } from '../../../stores/LocalizationStore.js'
import { useSettingStore } from '../../../stores/SettingStore.js'
import { openModal } from '../../../utilities/_helpers'
import Profile from '../../modals/Profile'
import { fix } from 'mathjs'
// import 'vue-select/dist/vue-select.css';
export default{
    components: {
        BCard,
        BButton,
        BRow,
        BCol,
        BAvatar,
        VueTelInput,
        AddPhoneComponent,
        'profile-modal': Profile
    },
    setup(){
        return {
            userStore: useUserStore(),
            localizationStore: useLocalizationStore(),
            settingStore: useSettingStore(),
            openModal: openModal,
            fix: fix,
        }
    },
    computed:{
    },
    props: {
        data: {
            type: Object,
            default: () => {},
        },
    },
    created() {
    },
    mounted(){
        let $this = this;
            if (document.readyState === "complete") {
                setTimeout(() => {
                    this.$nextTick(() => {
                        if(_.isEmpty(this.userStore.profile)){
                            $this.userStore.fetchUserProfile();
                        }
                    });
                }, 2000);
            } else {
                window.addEventListener("load", () => {
                    setTimeout(() => {
                        this.$nextTick(() => {
                            if(_.isEmpty(this.userStore.profile)){
                                $this.userStore.fetchUserProfile();
                            }
                        });
                    }, 2000);
                });
            }
    },
    watch: {
    },
    methods: {
        setDeactivateType(value){
            this.userStore.deactivate_type = value;
        }
    }
  }
</script>
